/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Requires_Team_AccountInputs */



/**
* | output |
* | --- |
* | "KNP Lookup requires a team account." |
*
* @param {Knp_Lookup_Requires_Team_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_requires_team_account = /** @type {((inputs?: Knp_Lookup_Requires_Team_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Requires_Team_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("La recherche KNP necessite un compte equipe.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für die KNP-Suche wird ein Teamkonto benötigt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per la ricerca KNP è necessario un account team.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для использования сервиса KNP Lookup требуется командная учетная запись.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La búsqueda de KNP requiere una cuenta de equipo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("KNP 查询需要团队帐户。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("KNP Lookup にはチーム アカウントが必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("KNP Lookup के लिए टीम अकाउंट आवश्यक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A ferramenta de busca KNP requer uma conta de equipe.")
	return /** @type {LocalizedString} */ ("KNP Lookup requires a team account.")
});